import { render, staticRenderFns } from "./registerUser.vue?vue&type=template&id=23eb703a&scoped=true"
import script from "./registerUser.vue?vue&type=script&lang=js"
export * from "./registerUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb703a",
  null
  
)

export default component.exports